<template>
    <b-container class="container-lg">
        <b-row class="pb-2">
            <b-col class="text-start text-truncate">
                <h5>
                    <i class="fa-solid fa-chevron-left" @click="goBack"></i> <i class="text-primary fa-solid fa-info"></i> {{ $t('Resource group') }}
                </h5>
            </b-col>
        </b-row>
        <b-list-group class="mt-3" v-if="ready">
            <b-list-group-item>
                <div class="d-flex w-100 justify-content-between">
                    <small class="ms-2 mb-1 col-4"><b>{{$t('Name')}}</b></small>
                    <small class="text-end">{{resourceGroup.container.name}}</small>
                </div>
                <div class="d-flex w-100 justify-content-between">
                    <small class="ms-2 mb-1 col-4"><b>{{$t('description')}}</b></small>
                    <small class="text-end">{{resourceGroup.description}}</small>
                </div>
                <small class="mt-2"><b>{{$t('Resource Summary')}}</b>
                 <div class="badge bg-primary-custom text-white ms-1"  @click="toResources(resourceGroup.id)">
                     {{resourceGroup.resource_count}} <i class="text-white fa-solid fa-eye"></i>
                 </div>
                </small>
                <small class="btn-group btn-group-justified w-100">
                    <router-link
                        class="btn btn-primary state-button-small"
                        :to="{name: 'resourcesIndex', query: {resourcegroups: resourceGroup.id, status: 0}}">
                        {{resourceGroup.statesummary[0]}}
                    </router-link>
                    <router-link
                        class="btn btn-success state-button-small"
                        :to="{name: 'resourcesIndex', query: {resourcegroups: resourceGroup.id, status: 1}}">
                        {{resourceGroup.statesummary[1]}}
                    </router-link>
                    <router-link
                        class="btn btn-warning state-button-small"
                        :to="{name: 'resourcesIndex', query: {resourcegroups: resourceGroup.id, status: 2}}">
                        {{resourceGroup.statesummary[2]}}
                    </router-link>
                    <router-link
                        class="btn btn-danger state-button-small"
                        :to="{name: 'resourcesIndex', query: {resourcegroups: resourceGroup.id, status: 3}}">
                        {{resourceGroup.statesummary[3]}}
                    </router-link>
                </small>

                <small class="mt-2"><b>{{$t('Region Managers')}}</b></small>
                <small v-if="resourceGroup.region_managers.length > 0">
                    <ul v-for="region_manager in resourceGroup.region_managers"
                        class="mb-0 ms-2 px-2">
                        <li>
                            {{region_manager.username}}
                        </li>
                    </ul>
                </small>
              <div class="text-danger ms-5" v-if="resourceGroup.region_managers.length === 0"><small>{{$t('Empty')}}</small></div>

                <small class="mt-2"><b>{{$t('Managers')}}</b></small>
                <small v-if="resourceGroup.managers.length > 0">
                    <ul v-for="manager in resourceGroup.managers"
                        class="mb-0 ms-2 px-2">
                        <li>
                            {{manager.username}}
                        </li>
                    </ul>
                </small>
                <div class="text-danger ms-5" v-if="resourceGroup.managers.length === 0">{{$t('Empty')}}</div>

                <small class="mt-2"><b>{{$t('Users')}}</b></small>
                <small v-if="resourceGroup.users.length > 0">
                    <ul v-for="user in resourceGroup.users"
                        class="mb-0 ms-2 px-2">
                        <li>
                            {{user.username}}
                        </li>
                    </ul>
                </small>
                <div class="text-danger ms-5" v-if="resourceGroup.users.length === 0">{{$t('Empty')}}</div>
              <small v-if="resourceGroup.mailinglist_users.length > 0" class="mt-2"><b>{{$t('Mailinglists')}}</b></small>
              <small v-if="resourceGroup.mailinglist_users.length > 0">
                <ul v-for="mailinglist in resourceGroup.mailinglist_users"
                    class="mb-0 ms-2 px-2">
                  <li>
                    {{mailinglist.name}}
                  </li>
                </ul>
              </small>
            </b-list-group-item>
        </b-list-group>
    </b-container>

</template>

<script>
import { BListGroupItem } from 'bootstrap-vue-next';

export default {
    name: "ResourceGroupInfo",
    components: {BListGroupItem},
    data() {
        return {
            ready: false,
            resourceGroup: {},
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        getData: function() {
            const id = this.$route.params.id;
            axios.post('/resources/resourceGroup.json', null, {
                params: {
                    id: id,
                }
            })
                .then(response => {
                    this.resourceGroup = response.data.response.all_resourcegroups[0] ?? {};
                    this.ready = true;
                })
                .catch(error => {
                    console.log(error)
                });
        },
        toResources: function (resourcegroup) {
            if(resourcegroup.length === 0) {
                return;
            }
            this.$router.push({ name: 'resourcesIndex', query: { resourcegroups: resourcegroup}});
        },
        goBack() {
            this.$router.go(-1);
        },
    }
}
</script>


<style scoped>
.state-button-small {
    padding: 0 2px;
    font-size: 12px;
}
</style>
